import api from "../../utils/api/api.utils";
export var deleteGenerator = function (paramsGenerator) {
    var resource = paramsGenerator.resource;
    return function (params) {
        return api.delete("/".concat(resource, "/").concat(params.id));
    };
};
